import axios from '@axios'

export default {
  namespaced: true,
  state: {
    posts: [],
    products: [],
    categories: [],
    ratings: [],
    cartItemsCount: (() => {
      const userData = JSON.parse(localStorage.getItem('userData'))
      return userData && userData.extras ? userData.extras.eCommerceCartItemsCount : 0
    })(),
  },
  getters: {
    getCurrentPosts(state) {
      return state.posts
    },
    getCurrentProducts(state) {
      return state.products
    },
    getCurrentCategories(state) {
      return state.categories
    },
    getCurrentRatings(state) {
      return state.ratings
    },
  },
   
  mutations: {
    UPDATE_CART_ITEMS_COUNT(state, count) {
      state.cartItemsCount = count
    },
    setCurrentPosts(state, posts) {
      state.posts = posts
    },
    setCurrentProducts(state, products) {
      state.products = products
    },
    setCurrentCategories(state, categories) {
      state.categories = categories
    },
    setCurrentRatings(state, ratings) {
      state.ratings = ratings
    },
  },
  actions: {
    // _az get all
    fetchProducts(context, payload) {
    let posts = []
      return new Promise((resolve, reject) => {
        axios.get('http://102.219.178.151/backend/api/posts').then(response => {
          posts = response.data.data
          console.log("pp hh ",posts)
          context.commit('setCurrentPosts', response.data.data)
          let products = []

          // creer un tableau pour les informations du produit seulement
          for (let i = 0; i < posts.length; i++) {
            products.push(posts[i].product)
            if (posts[i].ratings.length > 0)
              products[i].rating = posts[i].ratings[0].mark
            else
              products[i].rating = 0
            products[i].postId = posts[i]._id
            products[i].discount = posts[i].discount
           // products[i].typeTransaction = posts[i].typeTransaction
            products[i].typeTransaction = "Sale"
          }
           
          // décommenter pour tester un grand tableau de produit

          /*for (let j = 0; j < 27; j++) {
            let cp = Object.assign({}, products[0]);
            cp._id = j + 1
            cp.price = 500 + j
            if (j > 15) {
              cp.category = "camion"
            }
            cp.name = "aziz car" + j
            products.push(cp)
          }*/

          context.commit('setCurrentProducts', products)

          let cpt = 1

          // tableau de categories
          let categories = [{ text: "All", value: 0 }]
          
          // tableau des notes exemples [ { la note 5 (stars) apparait -> 2 fois }, { la note 3 apparait -> 6 fois } ]
          let tab_ratings = []

          for(let j =0 ; j <products.length ; j++) {
            var existocc = false;
             for(let g = 0 ; g < tab_ratings.length ; g ++)
              {
                if (tab_ratings[g].rating == products[j].rating )
                  {
                    existocc = true
                    break     
                  }
              } 
              if(!existocc) {
                 var nbrocc = 1
                 for(let f=j+1; f < products.length; f++) {
                  if(products[f].rating == products[j].rating)
                  nbrocc++
                 } 
                 let objrating = {}
                 objrating.rating = products[j].rating
                 objrating.count = nbrocc
                 tab_ratings.push(objrating)
             }
         
            var exist = false;
             for(let i = 0 ; i < categories.length ; i ++)
              {
                if (categories[i].text == products[j].category )
                  {
                    exist = true
                    break     
                  }
              } 
              if(!exist) {
                let obj = {}
                obj.text = products[j].category
                obj.value = cpt
                cpt++
                categories.push(obj)   
              }
        }

          context.commit('setCurrentCategories', categories)
          context.commit('setCurrentRatings', tab_ratings)
          
          resolve(products)
        }).catch(err => reject(err))
      })
    },
    // _az get 
    fetchProduct(ctx, { productId }) {
      if (productId == undefined) {
        return new Promise((resolve, reject) => {
          axios
            .get('http://102.219.178.151/backend/api/posts')
            .then(response => {
              resolve(response.data.data[0])
            })
            .catch(error => {
              reject(error)
            })
        })
      } else{
        return new Promise((resolve, reject) => {
          axios
            .get('http://102.219.178.151/backend/api/posts?id=' + productId)
            .then(response => {
              resolve(response.data.data)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    // _az delete
    removeProduct(context, { postId }) {
  
      return new Promise((resolve, reject) => {
        axios
          .delete('http://102.219.178.151/backend/api/posts/'+postId)
          .then(response => {

            /*let posts = context.getters.getCurrentPosts
            posts = posts.filter(
              (post) => post._id !== postId
            );
      
            context.commit('setCurrentPosts', posts)
      
            let products = context.getters.getCurrentProducts
            products = products.filter(
              (post) => post.postId !== postId
            );
      
            context.commit('setCurrentProducts', products)*/

            resolve(response)
          })
          .catch(error => resolve("error"))
      })
    },

    // _az edit 

    editProduct(ctx, product) {
      let id = product.postId
      let newpost = {}
      delete product.rating
      delete product.postId
      let posts = ctx.getters.getCurrentPosts
      for (let i = 0; i < posts.length; i++) {
        if (posts[i]._id === id) {
          newpost = posts[i]
          newpost.discount = product.discount
          newpost.typeTransaction = product.typeTransaction
          delete product.typeTransaction
          delete product.discount
          newpost.product = product
          break
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .put('http://102.219.178.151/backend/api/posts/'+id,newpost)
          .then(response => resolve(response))
          .catch(error => resolve("error"))
      })
      /*return new Promise((resolve, reject) => {
        axios
          .put('http://102.219.178.151/backend/api/products/'+id,product)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })*/
    },


    addProduct(ctx, product) {
     
      return new Promise((resolve, reject) => {
        axios
          .post('http://102.219.178.151/backend/api/posts',product)
          .then(response => resolve(response))
          .catch(error => resolve("error"))
      })
      
    },

    /************************************************************ */
    fetchWishlistProducts() {
      return new Promise((resolve, reject) => {
        var res = {"status":200,"data":{"products":[{"id":27,"name":"Apple Watch Series 5","slug":"apple-watch-series-5-27","brand":"Apple","price":339.99,"image":"/img/1.3b312012.png","hasFreeShipping":true,"rating":4,"description":"On Retina display that never sleeps, so it’s easy to see the time and other important information, without\n    raising or tapping the display. New location features, from a built-in compass to current elevation, help users\n    better navigate their day, while international emergency calling1 allows customers to call emergency services\n    directly from Apple Watch in over 150 countries, even without iPhone nearby. Apple Watch Series 5 is available\n    in a wider range of materials, including aluminium, stainless steel, ceramic and an all-new titanium.","isInWishlist":false,"isInCart":true},{"id":26,"name":"Apple iPhone 11 (64GB, Black)","slug":"apple-i-phone-11-64-gb-black-26","brand":"Apple","price":669.99,"image":"/img/2.1aba2cea.png","hasFreeShipping":true,"rating":5,"description":"The Apple iPhone 11 is a great smartphone, which was loaded with a lot of quality features. It comes with a\n    waterproof and dustproof body which is the key attraction of the device. The excellent set of cameras offer\n    excellent images as well as capable of recording crisp videos. However, expandable storage and a fingerprint\n    scanner would have made it a perfect option to go for around this price range.","isInWishlist":true,"isInCart":true},{"id":25,"name":"Apple iMac 27-inch","slug":"apple-i-mac-27-inch-25","brand":"Apple","price":999.99,"image":"/img/3.29c766f8.png","hasFreeShipping":true,"rating":4,"description":"The all-in-one for all. If you can dream it, you can do it on iMac. It’s beautifully & incredibly intuitive and\n    packed with tools that let you take any idea to the next level. And the new 27-inch model elevates the\n    experience in way, with faster processors and graphics, expanded memory and storage, enhanced audio and video\n    capabilities, and an even more stunning Retina 5K display. It’s the desktop that does it all — better and faster\n    than ever.","isInWishlist":false,"isInCart":true},{"id":24,"name":"OneOdio A71 Wired Headphones","slug":"one-odio-a71-wired-headphones-24","brand":"OneOdio","price":49.99,"image":"/img/4.73f34744.png","hasFreeShipping":true,"rating":3,"description":"Omnidirectional detachable boom mic upgrades the headphones into a professional headset for gaming, business,\n    podcasting and taking calls on the go. Better pick up your voice. Control most electric devices through voice\n    activation, or schedule a ride with Uber and order a pizza. OneOdio A71 Wired Headphones voice-controlled device\n    turns any home into a smart device on a smartphone or tablet.","isInWishlist":false,"isInCart":false},{"id":23,"name":"Apple - MacBook Air® (Latest Model) - 13.3\" Display - Silver","slug":"apple-mac-book-air-latest-model-13-3-display-silver-23","brand":"Apple","price":999.99,"image":"/img/5.c5b188e5.png","hasFreeShipping":false,"rating":4,"description":"MacBook Air is a thin, lightweight laptop from Apple. MacBook Air features up to 8GB of memory, a\n    fifth-generation Intel Core processor, Thunderbolt 2, great built-in apps, and all-day battery life.1 Its thin,\n    light, and durable enough to take everywhere you go-and powerful enough to do everything once you get there,\n    better.","isInWishlist":true,"isInCart":true},{"id":22,"name":"Switch Pro Controller","slug":"switch-pro-controller-22","brand":"Sharp","price":429.99,"image":"/img/6.833c8951.png","hasFreeShipping":false,"rating":3,"description":"The Nintendo Switch Pro Controller is one of the priciest \"baseline\" controllers in the current console\n    generation, but it's also sturdy, feels good to play with, has an excellent direction pad, and features\n    impressive motion sensors and vibration systems. On top of all of that, it uses Bluetooth, so you don't need an\n    adapter to use it with your PC.","isInWishlist":false,"isInCart":false},{"id":21,"name":"Google - Google Home - White/Slate fabric","slug":"google-google-home-white-slate-fabric-21","brand":"Google","price":129.29,"image":"/img/7.2a004c66.png","hasFreeShipping":true,"rating":4,"description":"Simplify your everyday life with the Google Home, a voice-activated speaker powered by the Google Assistant. Use\n    voice commands to enjoy music, get answers from Google and manage everyday tasks. Google Home is compatible with\n    Android and iOS operating systems, and can control compatible smart devices such as Chromecast or Nest.","isInWishlist":false,"isInCart":true},{"id":20,"name":"Sony 4K Ultra HD LED TV ","slug":"sony-4-k-ultra-hd-led-tv-20","brand":"Apple","price":7999.99,"image":"/img/8.c170e8ca.png","hasFreeShipping":false,"rating":5,"description":"Sony 4K Ultra HD LED TV has 4K HDR Support. The TV provides clear visuals and provides distinct sound quality\n    and an immersive experience. This TV has Yes HDMI ports & Yes USB ports. Connectivity options included are HDMI.\n    You can connect various gadgets such as your laptop using the HDMI port. The TV comes with a 1 Year warranty.","isInWishlist":false,"isInCart":false},{"id":19,"name":"OnePlus 7 Pro ","slug":"one-plus-7-pro-19","brand":"Philips","price":14.99,"image":"/img/9.3170c803.png","hasFreeShipping":false,"rating":4,"description":"The OnePlus 7 Pro features a brand new design, with a glass back and front and curved sides. The phone feels\n    very premium but’s it’s also very heavy. The Nebula Blue variant looks slick but it’s quite slippery, which\n    makes single-handed use a real challenge. It has a massive 6.67-inch ‘Fluid AMOLED’ display with a QHD+\n    resolution, 90Hz refresh rate and support for HDR 10+ content. The display produces vivid colours, deep blacks\n    and has good viewing angles.","isInWishlist":false,"isInCart":false}],"total":27,"userWishlist":[{"id":1,"productId":26},{"id":2,"productId":23},{"id":3,"productId":11},{"id":4,"productId":10},{"id":5,"productId":5},{"id":6,"productId":8},{"id":7,"productId":9},{"id":8,"productId":13},{"id":9,"productId":17}],"userCart":[{"id":1,"productId":27,"qty":1},{"id":2,"productId":21,"qty":1},{"id":3,"productId":26,"qty":1},{"id":4,"productId":25,"qty":1},{"id":5,"productId":23,"qty":1}]},"config":{"url":"/apps/ecommerce/products","method":"get","headers":{"Accept":"application/json, text/plain, */*","Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjI4MDU3OTA4LCJleHAiOjE2MjgwNTg1MDh9.JpzoAotrAcM3YUgObpRKddS6nIhUh5NEeZOwXIXgIFM"},"params":{"q":"","sortBy":"featured","page":1,"perPage":9},"transformRequest":[null],"transformResponse":[null],"timeout":0,"xsrfCookieName":"XSRF-TOKEN","xsrfHeaderName":"X-XSRF-TOKEN","maxContentLength":-1,"maxBodyLength":-1},"request":{"responseURL":"/apps/ecommerce/products"}}
        resolve(res)
        /*axios
          .get('/apps/ecommerce/wishlist')
          .then(response => resolve(response))
          .catch(error => reject(error))*/
      })
    },
    fetchCartProducts() {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/ecommerce/cart')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // ------------------------------------------------
    // Product Actions
    // ------------------------------------------------
    addProductInWishlist(ctx, { productId }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/ecommerce/wishlist', { productId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeProductFromWishlist(ctx, { productId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/apps/ecommerce/wishlist/${productId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addProductInCart(ctx, { productId }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/ecommerce/cart', { productId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeProductFromCart(ctx, { productId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/apps/ecommerce/cart/${productId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
